import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DefaultAlternateExtensionRequest, VoicemailAlternateExtension } from '../models/generated/ziroModels';
import { AuditHeaderService } from '../services/audit-header.service';

@Injectable()
export class VoicemailAlternateExtensionsResource {
  private http = inject(HttpClient);
  private _auditHeaderService = inject(AuditHeaderService);

  getAll(unityServerId: number, voicemailId: string): Observable<VoicemailAlternateExtension[]> {
    return this.http.get<VoicemailAlternateExtension[]>(
      `/services/cisco/macs/unity-servers/${unityServerId}/voicemails/${voicemailId}/alternate-extensions`,
    );
  }

  get(
    unityServerId: number,
    voicemailId: string,
    alternateExtensionId: string,
  ): Observable<VoicemailAlternateExtension> {
    return this.http.get<VoicemailAlternateExtension>(
      `/services/cisco/macs/unity-servers/${unityServerId}/voicemails/${voicemailId}/alternate-extensions/${alternateExtensionId}`,
    );
  }

  put(
    unityServerId: number,
    voicemailId: string,
    extension: string,
    alternateExtensionId: string,
    voicemailAlias: string,
  ): Observable<VoicemailAlternateExtension> {
    const httpHeaders = this._auditHeaderService.buildHeader([{ name: 'alias', value: voicemailAlias }]);
    return this.http.put<VoicemailAlternateExtension>(
      `/services/cisco/macs/unity-servers/${unityServerId}/voicemails/${voicemailId}/alternate-extensions/${alternateExtensionId}`,
      {
        id: alternateExtensionId,
        extension,
      },
      { headers: httpHeaders },
    );
  }

  delete(
    unityServerId: number,
    voicemailId: string,
    alternateExtensionId: string,
    voicemailAlias: string,
  ): Observable<void> {
    const httpHeaders = this._auditHeaderService.buildHeader([{ name: 'alias', value: voicemailAlias }]);
    return this.http.delete<void>(
      `/services/cisco/macs/unity-servers/${unityServerId}/voicemails/${voicemailId}/alternate-extensions/${alternateExtensionId}`,
      { headers: httpHeaders },
    );
  }

  post(
    unityServerId: number,
    voicemailId: string,
    extension: string,
    voicemailAlias: string,
  ): Observable<VoicemailAlternateExtension> {
    const httpHeaders = this._auditHeaderService.buildHeader([{ name: 'alias', value: voicemailAlias }]);
    return this.http.post<VoicemailAlternateExtension>(
      `/services/cisco/macs/unity-servers/${unityServerId}/voicemails/${voicemailId}/alternate-extensions`,
      {
        extension,
      },
      { headers: httpHeaders },
    );
  }

  getDefault(siteId: string, extension: string, endUserUsername: string): Observable<VoicemailAlternateExtension> {
    const postBody: DefaultAlternateExtensionRequest = { siteId, extension, endUserUsername };
    return this.http.post<VoicemailAlternateExtension>(
      '/services/cisco/defaults/voicemail/alternate-extension',
      postBody,
    );
  }
}
